import React from 'react';
import { motion } from 'framer-motion';
import { TypeAnimation } from 'react-type-animation';
import { Link } from 'react-scroll';
import { personalInfo } from '../data/portfolioData';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut' },
  },
};

const codeLines = [
  { number: 1, content: <><span className="syntax-keyword">const</span> <span className="syntax-function">developer</span> = {'{'}</> },
  { number: 2, content: <>&nbsp;&nbsp;<span className="syntax-variable">name</span>: <span className="syntax-string">"{personalInfo.name}"</span>,</> },
  { number: 3, content: <>&nbsp;&nbsp;<span className="syntax-variable">role</span>: <span className="syntax-string">"{personalInfo.title}"</span>,</> },
  { number: 4, content: <>&nbsp;&nbsp;<span className="syntax-variable">experience</span>: <span className="syntax-string">"{personalInfo.experience} years"</span>,</> },
  { number: 5, content: <>&nbsp;&nbsp;<span className="syntax-variable">availableForHire</span>: <span className="syntax-keyword">true</span>,</> },
  { number: 6, content: <>{'};'}</> },
];

const Hero = () => {
  return (
    <section id="hero" className="hero">
      <motion.div
        className="hero-content"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div className="terminal" variants={itemVariants}>
          <div className="terminal-header">
            <div className="terminal-dots">
              <span className="terminal-dot" style={{ background: '#ff5f56' }} />
              <span className="terminal-dot" style={{ background: '#ffbd2e' }} />
              <span className="terminal-dot" style={{ background: '#27c93f' }} />
            </div>
            <span className="terminal-title">durjoy@portfolio:~</span>
          </div>
          <div className="terminal-body">
            <div className="terminal-line">
              <span className="terminal-prompt">visitor@portfolio:~$</span>
              <TypeAnimation
                sequence={[
                  'Full Stack Engineer',
                  2000,
                  'React Developer',
                  2000,
                  'Node.js Expert',
                  2000,
                  'Cloud Architect',
                  2000,
                  'Problem Solver',
                  2000,
                ]}
                wrapper="span"
                speed={50}
                repeat={Infinity}
              />
              <span className="terminal-cursor">|</span>
            </div>
          </div>
        </motion.div>

        <motion.div className="code-block" variants={itemVariants}>
          {codeLines.map((line) => (
            <div className="code-line" key={line.number}>
              <span className="line-number">{line.number}</span>
              <span className="line-content">{line.content}</span>
            </div>
          ))}
        </motion.div>

        <motion.div className="hero-cta" variants={itemVariants}>
          <Link
            to="contact"
            smooth={true}
            duration={500}
            offset={-70}
            className="btn-primary"
          >
            Contact Me
          </Link>
          <Link
            to="projects"
            smooth={true}
            duration={500}
            offset={-70}
            className="btn-outline"
          >
            View Projects
          </Link>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
